import { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import useCompanyContext from 'common/hooks/useCompanyContext';
import Text from 'components/_core/Text';
import { logEvent } from 'features/Analytics/analytics';

import { NavLink } from './styles';
import { NavSubMenuItemProps } from './types';

const NavSubMenuItem: FC<NavSubMenuItemProps> = ({
  children,
  disabled,
  label,
  to,
}) => {
  const { companyProfileId, companyUserId } = useCompanyContext();

  return (
    <NavLink
      disabled={disabled}
      onClick={(): void => {
        logEvent({
          name: 'Click_Sub_Menu_Link',
          properties: {
            companyProfileId,
            companyUserId,
            label,
            to,
          },
        });
      }}
      sx={{
        '&[aria-current]': {
          _before: {
            backgroundColor: 'grey.800',
          },
          color: 'grey.800',
        },

        _before: {
          backgroundColor: 'transparent',
          bottom: 'space-4',
          content: '""',
          height: 1.5,
          left: 0,
          position: 'absolute',
          right: 0,
        },
        _hover: {
          color: 'grey.800',
        },
        color: 'grey.700',
        position: 'relative',
        width: 'fit-content',
      }}
      to={to}
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Text color="inherit" fontWeight="weight-500" variant="primary">
          {label}
        </Text>

        {children}
      </Flex>
    </NavLink>
  );
};

export default NavSubMenuItem;
